<template>
  <div class="home">
    <h2 class="title centered">Chris Watson</h2>
    <h3 class="subtitle centered">Designer / Developer / Wannbe Artist</h3>
    <div class="social-links">
      <a href="https://github.com/watzon"><fa :icon="['fab', 'github']" /></a>
      <a href="https://twitter.com/_watzon"><fa :icon="['fab', 'twitter']" /></a>
      <a href="https://instagram.com/watzondraws"><fa :icon="['fab', 'instagram']" /></a>
      <a href="https://dribbble.com/watzon"><fa :icon="['fab', 'dribbble']" /></a>
      <a href="https://keybase.io/watzon"><fa :icon="['fab', 'keybase']" /></a>
    </div>
    <div class="avatar-wrapper">
      <div class="avatar">
        <img src="../assets/img/avatar.jpg" alt="avatar photo">
      </div>
    </div>
  </div>
</template>

<style lang="stylus">
  @import "../assets/styl/grid"

  .social-links
    margin-bottom 15px
    text-align center
    font-size 22px
    display flex
    justify-content space-evenly
    center(350px)

  .avatar-wrapper
    margin-top 30px
    display flex
    align-items center
    justify-content center

    .avatar
      width min-content
      margin auto auto
      border-radius 50%
      overflow hidden
      border 2px solid #2c3e50

      img
        width 180px
</style>

<script>
import { mapState, mapActions } from 'vuex'
// import { CalendarHeatmap } from 'vue-calendar-heatmap'

export default {
  name: 'home',
  components: {
    // CalendarHeatmap
  },
  computed: {
    ...mapState(['contributions'])
  },
  methods: {
    ...mapActions(['fetchContributions'])
  },
  serverPrefetch () {
    return this.fetchContributions()
  },
  mounted () {
    return this.fetchContributions()
  }
}
</script>
